import { useFonts } from "expo-font";
import React from "react";
import { StyleSheet, Text as NativeText } from "react-native";
import { MD3Theme, useTheme } from "react-native-paper";
import PropTypes from "prop-types";

export const useCustomFonts = () => {
  return useFonts({
    "NotoSans-Black": require("../../assets/fonts/NotoSans_Condensed-Black.ttf"),
    "NotoSans-BlackItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-BlackItalic.ttf"),
    "NotoSans-Bold": require("../../assets/fonts/NotoSans_Condensed-Bold.ttf"),
    "NotoSans-BoldItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-BoldItalic.ttf"),
    "NotoSans-ExtraBold": require("../../assets/fonts/NotoSans_ExtraCondensed-ExtraBold.ttf"),
    "NotoSans-ExtraBoldItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-ExtraBoldItalic.ttf"),
    "NotoSans-Light": require("../../assets/fonts/NotoSans_Condensed-Light.ttf"),
    "NotoSans-LightItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-LightItalic.ttf"),
    "NotoSans-Medium": require("../../assets/fonts/NotoSans_ExtraCondensed-Medium.ttf"),
    "NotoSans-MediumItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-MediumItalic.ttf"),
    "NotoSans-Regular": require("../../assets/fonts/NotoSans_ExtraCondensed-Regular.ttf"),
    "NotoSans-RegularItalic": require("../../assets/fonts/NotoSans-Italic.ttf"),
    "NotoSans-SemiBold": require("../../assets/fonts/NotoSans_Condensed-SemiBold.ttf"),
    "NotoSans-SemiBoldItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-SemiBoldItalic.ttf"),
    "NotoSans-Thin": require("../../assets/fonts/NotoSans_Condensed-Thin.ttf"),
    "NotoSans-ThinItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-ThinItalic.ttf"),
    "NotoSans-ExtraLight": require("../../assets/fonts/NotoSans_ExtraCondensed-ExtraLight.ttf"),
    "NotoSans-ExtraLightItalic": require("../../assets/fonts/NotoSans_ExtraCondensed-ExtraLightItalic.ttf"),
    "PlayfairDisplay-Bold": require("../../assets/fonts/PlayfairDisplay-Bold.ttf"),
    "PlayfairDisplay-SemiBold": require("../../assets/fonts/PlayfairDisplay-SemiBold.ttf"),
    "PlayfairDisplay-Medium": require("../../assets/fonts/PlayfairDisplay-Medium.ttf"),
    "PlayfairDisplay-Regular": require("../../assets/fonts/PlayfairDisplay-Regular.ttf"),
  });
};

export const Text = ({ style = null, ...props }) => {
  const theme = useTheme();
  const styles = stylesGen(theme);
  return <NativeText style={[styles.customStyle, style]} {...props}>{props.children}</NativeText>;
};

Text.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node,
};

const stylesGen = (theme: MD3Theme) => StyleSheet.create({
  customStyle: {
    fontFamily: "NotoSans-Regular",
    color: theme.colors.onBackground,
  },
});

export function capitalizeFirstLetter(string: string) {
  if (!string) return string; // Retourne la chaîne originale si elle est vide
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function adjustText(text: string, maxWidth: number, fontSize: number) {
  // Hypothèse simpliste : 1 caractère = (fontSize * 0.5) pixels de largeur.
  // Cette hypothèse peut ne pas être précise pour toutes les polices et tous les caractères.
  const maxCharsPerLine = Math.floor(maxWidth / (fontSize * 0.5));
  let adjustedText = "";
  let currentLineLength = 0;

  text.split(" ").forEach(word => {
    // Si l'ajout du mot actuel dépasse la longueur maximale de la ligne,
    // ajoutez un saut de ligne avant ce mot (sauf pour le premier mot).
    if (currentLineLength + word.length > maxCharsPerLine && currentLineLength !== 0) {
      adjustedText += "\n";
      currentLineLength = 0;
    }

    // Ajoutez le mot à la ligne actuelle.
    adjustedText += (currentLineLength > 0 ? " " : "") + word;
    currentLineLength += word.length + (currentLineLength > 0 ? 1 : 0); // Ajoutez 1 pour l'espace si ce n'est pas le premier mot.
  });

  return adjustedText;
}